import { useEffect, useState } from "react";
import { api, extractError } from "@/lib/api";
import { PageContainer, PageHeader, EmptyState } from "@/components/app/PageShell";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ListChecks } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function AuditPage() {
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);

    const load = async (p = page) => {
        setLoading(true);
        try {
            const { data } = await api.get("/audit", { params: { page: p, page_size: 50 } });
            setItems(data.items); setTotal(data.total);
        } catch (e) { toast.error(extractError(e)); }
        finally { setLoading(false); }
    };

    useEffect(() => { load(page); /* eslint-disable-next-line */ }, [page]);

    return (
        <PageContainer>
            <PageHeader overline="Compliance" title="Audit Log" description="Every action across users, forms, roles, and records — chronologically." testid="audit-header" />
            {loading ? <div className="text-sm text-muted-foreground">Loading…</div> :
             items.length === 0 ? <EmptyState icon={ListChecks} title="No activity yet" testid="audit-empty" /> :
             (
                <>
                    <div className="brut-section overflow-hidden">
                        <table className="w-full" data-testid="audit-table">
                            <thead><tr>
                                <th className="data-header text-left">When</th>
                                <th className="data-header text-left">User</th>
                                <th className="data-header text-left">Action</th>
                                <th className="data-header text-left">Resource</th>
                                <th className="data-header text-left">IP</th>
                            </tr></thead>
                            <tbody>
                                {items.map((it) => (
                                    <tr key={it.id} data-testid={`audit-row-${it.id}`} className="hover:bg-secondary/50">
                                        <td className="data-cell font-mono text-xs">{new Date(it.created_at).toLocaleString()}</td>
                                        <td className="data-cell">{it.user_email || it.user_id || "—"}</td>
                                        <td className="data-cell"><Badge variant="outline" className="rounded-sm font-mono text-xs">{it.action}</Badge></td>
                                        <td className="data-cell text-sm"><span className="font-mono text-xs">{it.resource_type}</span> {it.resource_id ? `· ${it.resource_id.slice(0, 8)}…` : ""}</td>
                                        <td className="data-cell font-mono text-xs text-muted-foreground">{it.ip || "—"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="flex items-center justify-between mt-4 text-sm">
                        <div className="text-muted-foreground">Total: {total}</div>
                        <div className="flex gap-2">
                            <Button variant="outline" size="sm" className="rounded-sm" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="audit-prev">Previous</Button>
                            <div className="px-3 py-1 font-mono text-xs">{page}</div>
                            <Button variant="outline" size="sm" className="rounded-sm" disabled={page * 50 >= total} onClick={() => setPage(page + 1)} data-testid="audit-next">Next</Button>
                        </div>
                    </div>
                </>
             )
            }
        </PageContainer>
    );
}
